import React from 'react';

import "./YoutubeEmbed.scss";

// https://www.youtube.com/watch?v=hlkb623McOU
// https://youtu.be/hlkb623McOU
const YOUTUBE_URL_REGEX = /(?:youtube\.com\/(?:[^\/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-z0-9_-]{11})/gi

const YoutubeEmbed = function YoutubeEmbed ({videoUrl}) {
  const validVideoUrl = (videoUrl).match(YOUTUBE_URL_REGEX)

  if (!validVideoUrl) return null

  const videoId  = validVideoUrl[0].match(/[a-zA-z0-9]+$/)[0]

  return (
    <>
      <div className="youtube-vid-container">
        <iframe width="100%" height="100%"
          title="banner-video"
          src={`https://www.youtube-nocookie.com/embed/${videoId}?rel=0&modestbranding=1&autohide=1&showinfo=0`}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        />
      </div>
    </>
  )
}

export default React.memo(YoutubeEmbed)